interface BackdropProps {
  onClick?: VoidFunction;
}

export function Backdrop({ onClick }: BackdropProps) {
  return <div onClick={onClick} className="absolute inset-0 bg-black/60" />;
}
